import _classCallCheck from "C:/Jenkins/DeveloperPortal/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Jenkins/DeveloperPortal/workspace/node_modules/@babel/runtime/helpers/esm/createClass.js";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

/** A logger that does nothing when log messages are sent to it. */
export var NullLogger = /*#__PURE__*/function () {
  function NullLogger() {
    _classCallCheck(this, NullLogger);
  }
  /** @inheritDoc */
  // eslint-disable-next-line


  _createClass(NullLogger, [{
    key: "log",
    value: function log(_logLevel, _message) {}
  }]);

  return NullLogger;
}();
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */

NullLogger.instance = new NullLogger();